import { render, staticRenderFns } from "./Step-1-healthcare-candidate.vue?vue&type=template&id=0ec5b576&scoped=true&"
import script from "./Step-1-healthcare-candidate.vue?vue&type=script&lang=js&"
export * from "./Step-1-healthcare-candidate.vue?vue&type=script&lang=js&"
import style0 from "./Step-1-healthcare-candidate.vue?vue&type=style&index=0&id=0ec5b576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec5b576",
  null
  
)

export default component.exports